import styled from 'styled-components';

export const Base = styled.div`
	display: flex;
	flex-wrap: wrap;
	gap: 24px;
	align-items: flex-start;
	background-color: ${({ theme }) => theme.gray[100]};
	border-radius: 12px;
	padding: 32px;
`;

export const Card = styled.div<{ $shadow: string }>`
	width: 80px;
	height: 80px;
	background-color: ${({ theme }) => theme.gray[0]};
	border-radius: 8px;
	box-shadow: ${({ $shadow }) => $shadow};
`;
